import { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

export default function usePremium(userId) {
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (!userId) { setSubscription(null); return; }
    let cancelled = false;
    fetch(`${API_BASE}/billing/status?userId=${userId}`)
      .then(r => r.json())
      .then(d => { if (!cancelled) setSubscription(d.subscription || null); })
      .catch(() => { if (!cancelled) setSubscription(null); });
    return () => { cancelled = true; };
  }, [userId]);

  const isPremium = (() => {
    if (!subscription) return false;
    const { status, trial_ends_at } = subscription;
    if (status === 'active') return true;
    if (status === 'trialing' && trial_ends_at) return new Date() < new Date(trial_ends_at);
    return false;
  })();

  return { subscription, isPremium };
}
